export default __webpack_public_path__ + "static/media/beyondbooksorg.e0a51274.png";